import $ from '../init/jquery'
import merge from 'lodash/merge'
import each from 'lodash/each'
import debounce from 'lodash/debounce'
import MutationObserver from 'helpers/mutation-observer-helper'
import { okoPush } from 'helpers/oko-helpers'

/**
 * Формирует данные кастомного события для отправки в око.
 * @param {Event} e
 * @returns {Object}
 * @private
 */
const _getCustomOkoEventsData = e => {
  let element = $(e.currentTarget),
    category = element.data('oko-category'),
    withOnlyCategoryProp = element.data('oko-only-category'),
    event = e.type,
    data = {
      n: OKO_N.custom,
      category: category,
    }
  return withOnlyCategoryProp
    ? data
    : merge(data, OKO_DOM_DATA_EVENTS[event])
}

/**
 * Названия блоков с каруселями товаров
 */
export const OKO_ALGO = {
  sima_recommend: 'sima_recommend',
  sima_related: 'sima_related',
  sima_hit: 'sima_hit',
  sima_loco: 'sima_loco',
}

/**
 * Названия событий
 */
export const OKO_N = {
  add: 'rs-add',
  view: 'rs-view',
  click: 'rs-click',
  custom: 'custom',
}

export const OKO_CATEGORY = {
  related_manual: 'related_manual',
}

/**
 * Данные для отправки в око блока МЫ РЕКОМЕНДУЕМ
 */
export const OKO_WATCHER_OBJECT_LOCO = [{
  element: '.product__inner a, .js-item-title, .button_add2cart',
  event: 'click',
  data: e => {
    return {
      algo: OKO_ALGO.sima_recommend,
      n: $(e.currentTarget).hasClass('button_add2cart') ? OKO_N.add : OKO_N.click,
      sid: $(e.currentTarget).closest('.loco-item-popup').data('item'),
    }
  },
}]

/**
 * Данные "кастомных" событий для Ока
 * @type {{click: {custom_str: string}, mouseover: {custom_str: string}}}
 */
export const OKO_DOM_DATA_EVENTS = {
  click: {
    custom_str: ['click'],
  },
  touch: {
    custom_str: ['click'],
  },
  mouseover: {
    custom_str: ['hint'],
  },
}

/**
 * "Кастомные" элементы для отслеживания Оком
 * @type {{clickElement: string, hoverElement: string}}
 */
export const OKO_CUSTOM_EVENT_ELEMENTS = [
  {
    selector: '[data-oko-event-click]',
  },
  {
    selector: '[data-oko-event-touch]',
    onlyMobile: 'true',
    event: 'touchstart',
  },
  {
    selector: '[data-oko-event-hover]',
    event: 'mouseenter',
  },
]

/**
 * Данные для отправки в око хитов с нового дизайна категорий.
 */
export const OKO_WATCHER_NEW_CATEGORY_HITS_RECO = [{
  element: '.product .button_add2cart:not(.button_blue-clean), .product .product__detail .link',
  event: 'click',
  data: e => {
    return {
      algo: OKO_ALGO.sima_hit,
      n: $(e.currentTarget).hasClass('button_add2cart') ? OKO_N.add : OKO_N.click,
      sid: $(e.currentTarget).closest('[data-sid]').data('sid'),
    }
  },
}]

/**
 * Данные отправки в ОКО с блока табов подборок в блочном дизайне.
 * @param {string} algo Тип события.
 * @returns {Array} Данные для отправки.
 */
export const OKO_WATCHER_BLOCK_ITEMS_CATEGORY = algo => [{
  element: '.carousel-item .link',
  event: 'click',
  data: e => ({
    algo,
    n: OKO_N.click,
    sid: $(e.currentTarget).closest('[data-sid]').data('sid'),
  }),
}]

/**
 * Данные для отправки в око рекомендаций с нового дизайна категорий.
 * @param {string} algo Тип события.
 * @param {boolean} isMobile Признак отправки с мобильного.
 * @returns {Array} Данные для отправки в око.
 */
export const OKO_WATCHER_NEW_CATEGORY_THREE_RECO = (algo, isMobile) => {
  const element = isMobile
    ? '.product .product__inner .link'
    : '.block-items .item .js-oko-click'
  return [{
    element: element,
    event: 'click',
    data: e => {
      return {
        algo,
        n: OKO_N.click,
        sid: $(e.currentTarget).closest('[data-sid]').data('sid'),
      }
    },
  }]
}

/**
 * Данные для блоков рекоммендаций с динамическими ALGO
 * @param {string} algo Id события ока
 * @returns {Object} Параметры для OkoWatcher
 */
export const OKO_WATCHER_GET_OBJECT_WITH_ALGO = algo => {
  return [{
    element: '.product__inner a, .js-item-title, .button_add2cart',
    event: 'click',
    data: e => {
      return {
        algo: algo,
        n: $(e.currentTarget).hasClass('button_add2cart') ? OKO_N.add : OKO_N.click,
        sid: $(e.currentTarget).closest('[data-sid]').data('sid'),
      }
    },
  }]
}

/**
 * Статичная функция, которая формирует данные для OkoWatсher
 * @param {Object} el Элемент вью
 * @param {Array} watcherObjects Объекты с классами элементов, событиями и калбеком (см. выше)
 * @param {string} algo Id события ока
 * @param {Object} model Модель класса
 * @param {Object} mainWindow Объект окна браузера (для спрослушивания вьюпорта)
 * @returns {Object} Объект с данными для OkoWatcher
 */
export const OKO_WATCHER_GET_DATA = (el, watcherObjects, algo = null, model = null, mainWindow = null) => {
  return {
    el: el,
    algo: algo,
    model: model,
    mainWindow: mainWindow,
    okoWatcherObjects: watcherObjects,
  }
}

/**
 * Получение данных статических элементов, для отслеживания кастомных событий ОКО
 * @param {boolean} desktopCustomEvents - события для основной версии (клик, ховер)
 * @returns {Array}
 */
export const GET_STATIC_CUSTOM_EVENTS_DATA = (desktopCustomEvents = true) => {
  let okoWatcherData = []
  each(OKO_CUSTOM_EVENT_ELEMENTS, okoCustomElement => {
    if (desktopCustomEvents === !okoCustomElement.onlyMobile) {
      okoWatcherData.push({
        element: okoCustomElement.selector,
        event: okoCustomElement.event || 'click',
        data: okoCustomElement.data || _getCustomOkoEventsData,
      })
    }
  })

  return okoWatcherData
}

/**
 * Инициализация обновления данных для ОКО при перерисовке DOM
 * @param {Object} okoWatcher
 * @param {boolean} desktopCustomEvents - события для основной версии (клик, ховер)
 */
export const INIT_DYNAMIC_CUSTOM_EVENTS_UPDATE = (okoWatcher, desktopCustomEvents = true) => {
  // Инициализация наблюдателя за изменениями в DOM.
  const mutationCallback = debounce(mutations => {
    // Поиск среди измененных элементах тех, которые были добавлены
    each(mutations, mutation => {
      const addedNodes = mutation.addedNodes
      if (addedNodes.length) {
        // Поиск среди добавленных тех, которые нужно отслеживать Оком.
        each(addedNodes, node => {
          each(OKO_CUSTOM_EVENT_ELEMENTS, function (okoCustomElement) {
            let foundCustomElement = {}
            if (desktopCustomEvents === !okoCustomElement.onlyMobile) {
              foundCustomElement = $(node).find(okoCustomElement.selector)
            }
            if (foundCustomElement.length) {
              okoWatcher.updateWatcher([{
                element: okoCustomElement.selector,
                event: okoCustomElement.event || 'click',
                data: okoCustomElement.data || _getCustomOkoEventsData,
              }])
            }
          })
        })
      }
    })
  }, 500)
  MutationObserver(document, {
    subtree: true,
    childList: true,
  }, mutationCallback)
}

/**
 * Считает среднее время загрузки изображений и отправляет в око
 * @param {string} className класс нужных картинок
 * @param {string} eventName название события
 */
export const SEND_TO_OKO_RESOURCE_TIMING_LOAD_IMAGES = (className, eventName) => {
  let totalTimeSum = 0
  let totalItems = 0
  $(className).each((i, element) => {
    const elementSrcAttr = $(element).attr('src')
    if (elementSrcAttr
      && typeof window.performance.getEntriesByName === 'function'
      && window.performance.getEntriesByName(elementSrcAttr).length) {
      const imgPerformanceData = window.performance.getEntriesByName(elementSrcAttr)[0]
      totalTimeSum += parseInt(imgPerformanceData.duration)
      totalItems += 1
    }
  })
  if (totalItems >= 1) {
    okoPush({
      n: eventName,
      'avg_load': parseInt(totalTimeSum / totalItems),
    })
  }
}
